import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LANGUAGES, type Language } from './language';
import { translations } from './translations';

const LANGUAGE_KEY = 'geotra.language';

const defaultLanguage =
  [
    window.localStorage.getItem(LANGUAGE_KEY) || '',
    window.navigator.language.split('-')[0],
  ].find((language: string): language is Language => {
    return LANGUAGES.includes(language as Language);
  }) || 'en';

const initLanguage = (): void => {
  i18n.use(initReactI18next).init({
    resources: translations,
    lng: defaultLanguage,
    returnNull: false,
    returnEmptyString: true,
    interpolation: {
      escapeValue: false,
    },
    debug: false,
  });
};

const applyLanguage = (language: Language): void => {
  i18n.changeLanguage(language);
  window.localStorage.setItem(LANGUAGE_KEY, language);
};

export { defaultLanguage, initLanguage, applyLanguage };
